var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3118 19.166L8.47852 13.3327L10.1118 11.641L13.1452 14.6743V5.16602H15.4785V14.6743L18.5119 11.641L20.1452 13.3327L14.3118 19.166ZM7.31185 23.8327C6.67018 23.8327 6.12107 23.6044 5.66452 23.1479C5.20796 22.6913 4.97929 22.1418 4.97852 21.4993V17.9993H7.31185V21.4993H21.3118V17.9993H23.6452V21.4993C23.6452 22.141 23.4169 22.6905 22.9604 23.1479C22.5038 23.6052 21.9543 23.8335 21.3118 23.8327H7.31185Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9e2f042272c527c02872aaa33058fa34.svg";
export { ForwardRef as ReactComponent };